import moment from "moment";
import Vue from "vue";
import general from "@/wl-core/helpers/general";

export const Filters = {
    time(value){
        if (!value) return '-';
        value = value.toString();
        return moment(value).format('HH:mm')
    },
    date(value){
            if (!value) return '-';
            value = value.toString();
            return moment(value).format('DD/MM')
    },
    year(value) {
        if (!value) return '-';
        value = value.toString();
        return moment(value).format('YYYY')
    },
    fullDate(value) {
        if (!value) return '-';
        value = value.toString();
        return moment(value).format('DD/MM/YY')
    },
    fixed(value) {
        return general.round(value)
    },
    emptyString(value){
        if(!value && value !== '0'  ) return '-'
        return value;
    },
    month(value){
        if(!value && value !== '0') return '-'
        return moment(value).format('MMMM');
    }

};
